<template>
  <div>
    <el-collapse v-model="sizeActiveNames">
      <el-collapse-item title="尺寸" name="1">
        <template slot="title">
          尺寸
          <i class="tips-btn icon-portal-info2" @click.stop="explainDialog = true"></i>
          <span class="stop-blank" @click.stop></span>
          <div class="add-size" @click.stop
            v-if="(widthType === '自动' || widthType === '%' || heightType === '自动' || heightType === '%') && (!showMaxHeight || !showMinHeight || !showMaxWidth || !showMinWidth)">
            <el-dropdown @command="addHandleCommand" trigger="click">
              <span class="el-dropdown-link icon-portal-plus"></span>
              <el-dropdown-menu slot="dropdown" class="custom-menu">
                <el-dropdown-item v-for="(size, index) in sizeLists" :key="'size' + index" :command="size.value"
                  v-show="size.show"><span class="icon" :class="size.icon"></span>{{ size.label }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
        <div class="content clearFloat">
          <div class="verticallyCenter">
            <div class="verticallyCenter mr12">
              <span class="fs14 mr8">宽</span>
              <el-input :type="widthType === 'px' ? 'number' : ''"
                        :class="['input-size',disabledWidth ? 'disabledInput' : '']"
                        placeholder="-"
                        v-model="tempWidth"
                        @focus="getFocus($event)"
                        @blur="blurEvent('newWidth','tempWidth')"
                        @keyup.native="keyupEvent($event,'newWidth','tempWidth')"
                        :disabled="disabledWidth">
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="widthTypeHandleCommand">
                    <span class="el-dropdown-link lineHeight32" v-if="widthType === 'px'">
                      {{ widthType }}
                    </span>
                    <span class="el-dropdown-link lineHeight32" :class="widthIcon" v-else></span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item v-for="(sizeType, index) in widthTypes" :command="sizeType.value"
                        :key="'sizeType_' + index">
                        <span class="selected-icon"
                          :class="widthType === sizeType.value ? 'icon-portal-check-small' : ''"></span>
                        {{ sizeType.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-input>
            </div>
            <div class="verticallyCenter">
              <span class="fs14 mr8">高</span>
              <el-input :type="heightType === 'px' ? 'number' : ''"
                        :class="['input-size',disabledHeight ? 'disabledInput' : '']"
                        placeholder="-"
                        v-model="tempHeight"
                        @focus="getFocus($event)"
                        @blur="blurEvent('newHeight','tempHeight')"
                        @keyup.native="keyupEvent($event,'newHeight','tempHeight')"
                        :disabled="disabledHeight">
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="heightTypeHandleCommand">
                    <span class="el-dropdown-link lineHeight32" v-if="heightType === 'px'">
                      {{ heightType }}
                    </span>
                    <span class="el-dropdown-link lineHeight32" :class="heightIcon" v-else></span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item v-for="(sizeType, index) in heightTypes" :key="index" :command="sizeType.value">
                        <span class="selected-icon"
                          :class="heightType === sizeType.value ? 'icon-portal-check-small' : ''"></span>
                        {{ sizeType.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-input>
            </div>
          </div>
          <div class="verticallyStart">
            <div style="width: 50%;padding-right: 6px;">
              <div class="verticallyCenter mt8" v-if="showMaxWidth">
                <span class="fs14 mr8 icon-portal-max-width"></span>
                <el-input class="input-size"
                          placeholder="最大宽"
                          v-model="tempMaxWidth"
                          @blur="blurEvent('maxWidth','tempMaxWidth')"
                          @keyup.native="keyupEvent($event,'maxWidth','tempMaxWidth')"
                          @focus="getFocus($event)">
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMaxWidth')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item>
                          <span class="icon icon-portal-close-small"></span>移除最大宽度
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
              <div class="verticallyCenter mt8" v-if="showMinWidth">
                <span class="fs14 mr8 icon-portal-min-width"></span>
                <el-input class="input-size"
                          placeholder="最小宽"
                          v-model="tempMinWidth"
                          @blur="blurEvent('minWidth','tempMinWidth')"
                          @keyup.native="keyupEvent($event,'minWidth','tempMinWidth')"
                          @focus="getFocus($event)">
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMinWidth')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item>
                          <span class="icon icon-portal-close-small"></span>移除最小宽度
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
            </div>
            <div style="width: 50%;padding-left: 6px;">
              <div class="verticallyCenter mt8" v-if="showMaxHeight">
                <span class="fs14 mr8 icon-portal-max-height"></span>
                <el-input class="input-size" placeholder="最大高" v-model="tempMaxHeight"
                  @blur="blurEvent('maxHeight','tempMaxHeight')"
                          @keyup.native="keyupEvent($event,'maxHeight','tempMaxHeight')"
                  @focus="getFocus($event)">
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMaxHeight')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item>
                          <span class="icon icon-portal-close-small"></span>移除最大高度
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
              <div class="verticallyCenter mt8" v-if="showMinHeight">
                <span class="fs14 mr8 icon-portal-min-height"></span>
                <el-input class="input-size" placeholder="最小高"
                          v-model="tempMinHeight"
                          @blur="blurEvent('minHeight','tempMinHeight')"
                          @keyup.native="keyupEvent($event,'minHeight','tempMinHeight')"
                          @focus="getFocus($event)">
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMinHeight')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item>
                          <span class="icon icon-portal-close-small"></span>移除最小高度
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import silderAndInput from "modules/components/sliderAndInput.vue"
import rectPositionSet from "publicSetting/rect-position-set"
import { findParentIds, isExist, fixOptName } from "utils"
import $ from "jquery"
export default {
  components: { silderAndInput, rectPositionSet },
  props: {
    ids: {
      type: Object
    },
    options: Object,
    mouseType: {
      default: "default",
      type: String
    },
    disableAuto: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sizeActiveNames: ["1", "2"],
      widthTypes: [
        {
          label: "固定宽度",
          value: "px"
        },
        {
          label: "充满布局",
          value: "%",
          icon: "icon-portal-fill-width",
        },
        {
          label: "适应内容",
          value: "自动", // 该名称是为了直接用之前的逻辑不能修改
          icon: "icon-portal-auto-width",
        }
      ],
      heightTypes: [
        {
          label: "固定高度",
          value: "px"
        },
        {
          label: "充满布局",
          value: "%",
          icon: "icon-portal-fill-height",
        },
        {
          label: "适应内容",
          value: "自动", // 该名称是为了直接用之前的逻辑不能修改
          icon: "icon-portal-hug-height",
        }
      ],
      sizeLists: [
        {
          label: "最大宽度",
          value: "showMaxWidth",
          icon: "icon-portal-max-width",
          show: true
        },
        {
          label: "最小宽度",
          value: "showMinWidth",
          icon: "icon-portal-min-width",
          show: true
        }, {
          label: "最大高度",
          value: "showMaxHeight",
          icon: "icon-portal-max-height",
          show: true
        }, {
          label: "最小高度",
          value: "showMinHeight",
          icon: "icon-portal-min-height",
          show: true
        },
      ],
      handleList: [],
      tempWidth:0,
      tempHeight:0,
      tempMinWidth:0,
      tempMaxWidth:0,
      tempMinHeight:0,
      tempMaxHeight:0
    }
  },
  watch: {
    ids: {
      handler: function (newVal, oldVal) {
        this.handleList = findParentIds(
          this.ids,
          this.$store.state[this.request_prefix].page.pageLayoutType,
          this.$store.state[this.request_prefix]
        )
        if(!this.handleList){
          //  此时dom 还可能未渲染完成
          return
        }
        let handleInfo = this.handleList[1]
        let parentNode = this.getElementNode(handleInfo)
        this.parentW = parentNode?.width()
        this.parentH = parentNode?.height()
      },
      immediate: true,
      deep: true
    },
    width(newVal, oldVal) {
      if (newVal !== oldVal) {
        // this.setInputMaxMin()
      }
    },
    height(newVal, oldVal) {
      if (newVal !== oldVal) {
        // this.setInputMaxMin()
      }
    },
    left(newVal, oldVal) {
      if (newVal !== oldVal) {
        // this.setInputMaxMin()
      }
    },
    top(newVal, oldVal) {
      if (newVal !== oldVal) {
        // this.setInputMaxMin()
      }
    },
    newWidth(newVal, oldVal){
      if (newVal !== oldVal) {
        this.tempWidth = isNaN(newVal) ? newVal : parseInt(newVal)
      }
    },
    newHeight(newVal, oldVal){
      if (newVal !== oldVal) {
        this.tempHeight = isNaN(newVal) ? newVal : parseInt(newVal)
      }
    },
    minWidth(newVal, oldVal){
      if (newVal !== oldVal) {
        this.tempMinWidth = newVal
      }
    },
    minHeight(newVal, oldVal){
      if (newVal !== oldVal) {
        this.tempMinHeight = newVal
      }
    },
    maxWidth(newVal, oldVal){
      if (newVal !== oldVal) {
        this.tempMaxWidth = newVal
      }
    },
    maxHeight(newVal, oldVal){
      if (newVal !== oldVal) {
        this.tempMaxHeight = newVal
      }
    },
  },
  computed: {
    isAutoLayoutInCol() {
      return this.options.isNoConflictCheck
    },
    isQuickSite: {
      get() {
        if (this.options.hasOwnProperty("isQuickSite")) {
          return this.options.isQuickSite
        }
        return false
      },
      set(newVal) {
        if (newVal) {
          // 开启快捷定位之后，定位到第一个
          this.left = 0
          this.top = 0
          this.leftType = "%"
          this.topType = "%"
        } else {
          let curRect = document.getElementsByClassName("vdr active")
          let curRectParent = curRect[0]?.parentNode
          if (curRect[0] && curRectParent) {
            // 关闭快捷定位后，将百分比换算为px
            this.leftType = "px"
            this.topType = "px"
            let rectSite = curRect[0].getBoundingClientRect()
            let parentRectSite = curRectParent.getBoundingClientRect()
            this.left = parseInt(rectSite.left - parentRectSite.left)
            this.top = parseInt(rectSite.top - parentRectSite.top)
          }
        }
        this.$changeOptionsEV(newVal, "isQuickSite", false)
      }
    },
    zIndex: {
      get() {
        return this.options.zIndex || 0
      },
      set(newVal) {
        let optionName = this.mouseType === "hover" ? "hoverZIndex" : "zIndex"
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    isShowLeftPerc() {
      return this.baseComponent.indexOf(this.options.innerElement) > -1 ? true : false
    },
    showQuickPosition() {
      if (this.isShowLeftPerc && (this.leftType === "%" || this.topType === "%")) {
        return true
      }
      return false
    },
    isDraggable() {
      if (this.options && !this.options.hasOwnProperty("draggable")) {
        return true
      }
      return this.options.draggable
    },
    newWidth: {
      get() {
        if (this.widthType === "%") return "充满"
        else if (this.widthType === "自动") return "适应"
        else return parseInt(this.width)
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.$changeOptionsEV(newVal, "width", false)
      }
    },
    newHeight: {
      get() {
        if (this.heightType === "%") return "充满"
        else if (this.heightType === "自动") return "适应"
        else return parseInt(this.height)
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.$changeOptionsEV(newVal, "height", false)
      }
    },
    width: {
      get() {
        if (this.isPageLayout && !this.options.width) {
          this.$changeOptionsEV(100, "width", false)
          this.$changeOptionsEV("%", "widthType", false)
          return 100
        }
        return this.options.width
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        // if (this.request_prefix !== 'bigScreen') {
        //   newVal = newVal > this.maxWidth ? this.maxWidth : newVal
        // }
        let optionName = this.mouseType === "hover" ? "hoverWidth" : "width"
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    height: {
      get() {
        return this.options.height
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        // if (this.request_prefix !== 'bigScreen') {
        //   newVal = newVal > this.maxHeight ? this.maxHeight : newVal
        // }
        let optionName = this.mouseType === "hover" ? "hoverHeight" : "height"
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    disabledWidth() {
      if (this.widthType === "%" || this.widthType === "自动") return true
      else return false
    },
    disabledHeight() {
      if (this.heightType === "%" || this.heightType === "自动") return true
      else return false
    },
    margin: {
      get() {
        return this.options.margin
      },
      set(newVal) {
        if (newVal) {
          this.topType = "%"
          this.leftType = "%"
        }
        this.$changeOptionsEV(newVal, "margin", false)
      }
    },
    offset: {
      get() {
        return this.options.offset
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "offset", false)
      }
    },
    left: {
      get() {
        return this.options.left
      },
      set(newVal) {
        if (this.leftType === "%") {
          newVal = newVal < 0 ? 0 : newVal > 100 ? 100 : newVal
        } else {
          if (this.request_prefix !== 'bigScreen') {
            newVal = newVal < 0 ? 0 : newVal
            newVal = newVal > this.maxLeft ? this.maxLeft : newVal
          }
        }
        let optionName = this.mouseType === "hover" ? "hoverLeft" : "left"
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    top: {
      get() {
        return this.options.top
      },
      set(newVal) {
        if (this.request_prefix !== 'bigScreen') {
          newVal = newVal < 0 ? 0 : newVal
          newVal = newVal > this.maxTop ? this.maxTop : newVal
        }
        let optionName = this.mouseType === "hover" ? "hoverTop" : "top"
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    rotate: {
      get() {
        return this.options.rotate
      },
      set(newVal) {
        let optionName = this.mouseType === "hover" ? "hoverRotate" : "rotate"
        if (newVal == this[optionName]) return
        this.$changeOptionsEV(newVal, optionName, false)
      }
    },
    leftType: {
      get() {
        return this.options.leftType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "leftType", false)
      }
    },
    topType: {
      get() {
        return this.options.topType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topType", false)
      }
    },
    widthType: {
      get() {
        if (this.isPageLayout && !this.options.width) {
          return "%"
        }
        return this.options.widthType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthType", false)
      }
    },
    heightType: {
      get() {
        return this.options.heightType || "px"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "heightType", false)
      }
    },
    widthIcon() {
      return this.widthTypes?.find(item => item.value === this.widthType)?.icon
    },
    heightIcon() {
      return this.heightTypes?.find(item => item.value === this.heightType)?.icon
    },
    showPosition() {
      return this.showSetItem === "position"
    },
    showSize() {
      return this.showSetItem === "size"
    },
    showIndex() {
      return this.showSetItem === "index"
    },
    showRotate() {
      return this.showSetItem === "rotate"
    },
    // 翻页模板
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    isAdmin() {
      return this.$store.state.states.managerType === 0 ? false : true
    },
    showMaxWidth: {
      get() {
        return this.options.hasOwnProperty("showMaxWidth") ? this.options.showMaxWidth : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showMaxWidth", false)
      }
    },
    showMinWidth: {
      get() {
        return this.options.hasOwnProperty("showMinWidth") ? this.options.showMinWidth : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showMinWidth", false)
      }
    },
    showMaxHeight: {
      get() {
        return this.options.hasOwnProperty("showMaxHeight") ? this.options.showMaxHeight : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showMaxHeight", false)
      }
    },
    showMinHeight: {
      get() {
        return this.options.hasOwnProperty("showMinHeight") ? this.options.showMinHeight : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showMinHeight", false)
      }
    },
    maxWidth: {
      get() {
        return this.options.hasOwnProperty("maxWidth") ? this.options.maxWidth : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "maxWidth", false)
      }
    },
    minWidth: {
      get() {
        return this.options.hasOwnProperty("minWidth") ? this.options.minWidth : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "minWidth", false)
      }
    },
    maxHeight: {
      get() {
        return this.options.hasOwnProperty("maxHeight") ? this.options.maxHeight : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "maxHeight", false)
      }
    },
    minHeight: {
      get() {
        return this.options.hasOwnProperty("minHeight") ? this.options.minHeight : ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "minHeight", false)
      }
    },
  },
  mounted() {
    this.initData()
    // this.colIsAutoLayout = sessionStorage.getItem("colIsAutoLayout")
    this.sizeLists.forEach(item => {
      Object.assign(item, {
        show: !this[item.value]
      })
    })
    if (this.disableAuto) {// 不能自适应尺寸
      this.widthTypes.splice(2, 1)
      this.heightTypes.splice(2, 1)
    }
  },
  methods: {
    initData(){
      this.tempWidth = this.newWidth
      this.tempHeight = this.newHeight
      this.tempMinWidth = this.minWidth
      this.tempMaxWidth = this.maxWidth
      this.tempMinHeight = this.minHeight
      this.tempMaxHeight = this.maxHeight
    },
    keyupEvent(e,originName,name){
      this.keyDownEvent(e,originName,name)
    },
    keyDownEvent(e,originName,name){
      let key = window.event.keyCode
      //enter键  待完善
      if ((key === 38 || key === 40) && this.isFocus) {
        e.target.select()
        setTimeout(()=>{
          this.setValue(originName,name)
        },50)
      }
    },
    getElementNode(handleInfo) {
      if (this.request_prefix === 'bigScreen' || !handleInfo) return
      let parentNode
      switch (handleInfo.shape) {
        case "colsComponent":
          parentNode = $(`#${handleInfo.ids.uid}`)
          break
        case "cxPageLayoutCell":
          parentNode =
            handleInfo.ids.pageLayoutId.length === 1
              ? $(`.pageLayout_id_${handleInfo.ids.pageLayoutId}`)
              : $(`#layout_${handleInfo.ids.pageLayoutId}`)
          break
        case "cxPageLayout":
          parentNode = $(`.pageLayout_id_${handleInfo.ids.pageLayoutId}`)
          break
        case "page":
          parentNode = $(`#container_${handleInfo.ids.container_id}`)
          break
        default:
          if (handleInfo.ids.uid) {
            parentNode = $(
              `.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}-uid_${handleInfo.ids.uid}-elementInLayoutId_${handleInfo.ids.elementInLayoutId}`
            )
          } else if (handleInfo.ids.elementInAutoLayoutId !== undefined) {            
            parentNode = $(`.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}-elementInAutoLayoutId_${handleInfo.ids.elementInAutoLayoutId}-path_${handleInfo.ids.path ? handleInfo.ids.path.join('') : handleInfo.ids.path}`)
          } else {
            parentNode = $(`.container_id_${handleInfo.ids.container_id}-rect_id_${handleInfo.ids.rect_id}`)
        }
      }
      return parentNode
      // this.setInputMaxMin()
    },
    // 计算输入框的最大最小值
    setInputMaxMin() {
      if (this.request_prefix === 'bigScreen') return
      // 快捷定位之后，最大宽度/高度选择父容器的高度
      if (this.options.isQuickSite) {
        this.maxWidth = this.parentW
        this.maxHeight = this.parentH
        this.maxLeft = 100
        this.maxTop = 100
      } else {
        let currentWidth = this.widthType === "%" ? parseInt((this.width * this.parentW) / 100) : this.width
        let currentHeight = this.heightType === "%" ? parseInt((this.height * this.parentH) / 100) : this.height
        let currentLeft = this.leftType === "%" ? parseInt((this.left * this.parentH) / 100) : this.left
        let currentTop = this.leftType === "%" ? parseInt((this.top * this.parentH) / 100) : this.top
        let offsetLeft = 0
        let offsetTop = 0
        if (this.leftType === "%") {
          offsetLeft = this.options.offset ? this.options.offset[1] + this.options.offset[3] : 0
        }
        if (this.topType === "%") {
          offsetTop = this.options.offset ? this.options.offset[0] + this.options.offset[2] : 0
        }
        // console.log('this.parentW :>>', this.parentW, this.parentH, currentWidth, currentHeight, currentLeft, currentTop);
        this.maxWidth = this.widthType === "%" ? 100 : Math.floor(this.parentW - currentLeft - offsetLeft)
        this.maxWidth === 0 ? this.maxWidth = currentWidth : ""
        this.maxHeight = this.heightType === "%" ? 100 : Math.floor(this.parentH - currentTop - offsetTop)
        this.maxHeight === 0 ? this.maxHeight = currentHeight : ""
        this.maxLeft = this.leftType === "%" ? 100 : Math.floor(this.parentW - currentWidth)
        this.maxTop = this.topType === "%" ? 100 : Math.floor(this.parentH - currentHeight)
        // console.log('this.maxWidth :>>', this.maxWidth, this.maxHeight, this.maxLeft, this.maxTop);
      }
    },
    // 切换快捷定位的开关
    changeQuickSite() {
      this.isQuickSite = !this.isQuickSite
      this.margin = 0
      this.offset = 0
      this.setInputMaxMin()
    },
    // fixGetNumber(name) {
    //   const num =
    //     this.mouseType === "hover" ? this.options["hover" + name[1].toUpperCase() + name.slice(1)] : this.options[name]
    //   if (String(num).includes(".")) {
    //     return String(num).split(".")[1].length > 2 ? num.toFixed(2) : num
    //   } else return num
    // },
    fixSetNumber(num) {
      if (String(num).includes(".")) {
        return String(num).split(".")[1].length > 2 ? num.toFixed(2) : num
      }
      return num
    },
    leftTypeHandleCommand(val) {
      if (this.leftType === val) {
        return
      }
      this.leftType = val
      this.left = 0
      this.margin = null
      this.offset = null
    },
    topTypeHandleCommand(val) {
      if (this.topType === val) {
        return
      }
      this.topType = val
      this.top = 0
      this.margin = null
      this.offset = null
    },
    /* 当前设置充满时，判断父级元素是否为自适应，是自动转换成固定宽高（同向判断其中一个充满，不同向判断所有都是充满） */
    setParent(type) {
      if (this.ids.uid || this.ids.hasOwnProperty("directionIndex")) return
      let parentIds = {}
      if (this.handleList.length > 0) {
        parentIds = this.handleList[1]?.ids
      } else {
        this.handleList = findParentIds(
          this.ids,
          this.$store.state[this.request_prefix].page.pageLayoutType,
          this.$store.state[this.request_prefix]
        )
        parentIds = this.handleList[1]?.ids
      }
      let parentRect = null
      let stage = this.$store.state[this.request_prefix]
      if (parentIds.hasOwnProperty("pageLayoutId") && parentIds.pageLayoutId) {
        parentRect = this.getAttrById(stage, parentIds, "pageLayout")
      } else {
        parentRect = this.getAttrById(stage, parentIds, "autoLayout")
      }
      let options = parentRect.options ? parentRect.options : parentRect
      let showRowColLayout = options.showRowColLayout
      if (!showRowColLayout) return
      let allFill = true
      if (options[type] === "自动") {
        let elementOptions = options.elementOptions // 自动布局
        let { boundWidth, boundHeight } = this.getBoundSize(parentIds)
        // if ((options.rowColDirection === "horizon" && type === "heightType") || (options.rowColDirection !== "horizon" && type === "widthType")) {// 水平需要判断所有高度都是充满 或者 垂直判断所有宽度都是充满
        //   if (elementOptions) {
        //     allFill = elementOptions.every(item => {
        //       // let noElement = !item.elementOptions || item.elementOptions.length === 0
        //       return item[type] === "%"
        //     })
        //   } else {// 通栏布局
        //     allFill = parentRect.rectIds?.every(item => {
        //       let rectAttr = this.getAttrById(
        //         stage,
        //         {
        //           container_id: this.ids.container_id,
        //           rect_id: item
        //         },
        //         "rect"
        //       )
        //       let rect = rectAttr?.options
        //       let noElement = !rect.elementOptions || rect.elementOptions.length === 0
        //       return rect[type] === "%" && noElement
        //     })
        //   }
        // }
        if (!parentIds.hasOwnProperty("rect_id")) {// 通栏布局
          let paddingTopBottom = options.padding * 2
          let paddingLeftRight = options.padding * 2
          if (Array.isArray(options.padding)) {
            paddingTopBottom = options.padding[0] + options.padding[2]
            paddingLeftRight = options.padding[1] + options.padding[3]
          }
          boundWidth = options.boundWidth + paddingLeftRight
          boundHeight = options.boundHeight + paddingTopBottom
        }
        console.log('boundHeight :>>', boundWidth, boundHeight);
        if (allFill) {
          if (type === "heightType" && boundHeight) {// 修改父级高度为固定
            this.$changeOptionsEV(boundHeight, "height", null, false, parentIds)
            this.$changeOptionsEV("px", "heightType", null, false, parentIds)
          }
          if (type === "widthType" && boundWidth) {// 修改父级宽度为固定
            this.$changeOptionsEV(boundWidth, "width", null, false, parentIds)
            this.$changeOptionsEV("px", "widthType", null, false, parentIds)
          }
        }
      }
    },
    // 获取元素的真实尺寸
    getBoundSize(ids) {
      if (ids.hasOwnProperty("rect_id")) {
        let path = `${ids.path ? ids.path.join('') : ids.path}`
        let className = ids.uid ? `container_id_${ids.container_id}-rect_id_${ids.rect_id}-uid_${ids.uid}-elementInLayoutId_${ids.elementInLayoutId}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${path}` : `container_id_${ids.container_id}-rect_id_${ids.rect_id}-elementInAutoLayoutId_${ids.elementInAutoLayoutId}-path_${path}`
        if (!ids.hasOwnProperty("elementInAutoLayoutId")) {
          className = `container_id_${ids.container_id}-rect_id_${ids.rect_id}`
        }
        let element = document.getElementsByClassName(className)[0]
        let rect = element?.getBoundingClientRect()
        if (rect) {
          let boundWidth = rect.width
          let boundHeight = rect.height
          this.$changeOptionsEV(boundWidth, "boundWidth", null, false, ids)
          this.$changeOptionsEV(boundHeight, "boundHeight", null, false, ids)
          return { boundWidth, boundHeight }
        }
      }
      return {}
    },
    /* 当前设置自适应时, 需要判断子元素是否是充满，是需要改成固定宽高 */
    setChild(type) {
      let elementOptions = this.options.elementOptions
      if (!elementOptions) return
      let allFill = true
      if ((this.options.rowColDirection === "horizon" && type === "heightType") || (this.options.rowColDirection !== "horizon" && type === "widthType")) {// 水平需要判断所有高度都是充满 或者 垂直判断所有宽度都是充满
        allFill = elementOptions.every(item => {
          return item[type] === "%"
        })
      }
      if (!allFill) return
      elementOptions.forEach(item => {
        let ids = {
          ...this.ids,
          elementInAutoLayoutId: item.elementInAutoLayoutId,
          path: item.path
        }
        let { boundWidth, boundHeight } = this.getBoundSize(ids)
        if (allFill && item[type] === "%") {
          if (type === "heightType" && boundHeight) {// 修改子元素高度为固定
            this.$changeOptionsEV(boundHeight, "height", null, false, ids)
            this.$changeOptionsEV("px", "heightType", null, false, ids)
          }
          if (type === "widthType" && boundWidth) {// 修改子元素宽度为固定
            this.$changeOptionsEV(boundWidth, "width", null, false, ids)
            this.$changeOptionsEV("px", "widthType", null, false, ids)
          }
        }
      })
    },
    widthTypeHandleCommand(val) {
      if (this.widthType === val) {
        return
      }
      this.widthType = val
      if (val === "%") {
        this.setParent("widthType")
        this.width = 100
      } else if (val === "自动") {
        this.setChild("widthType")
        this.width = "auto"
      } else {
        let zoom = this.$store.state[this.request_prefix]?.page?.zoom || 1
        let { boundWidth } = this.getBoundSize(this.ids)
        boundWidth = boundWidth / zoom // 有缩放的情况元素尺寸不是实际尺寸
        this.width = Math.round(boundWidth) || 400
        this.showMaxWidth = false
        this.showMinWidth = false
        this.sizeLists.forEach(item => {
          if (item.value === "showMaxWidth" || item.value === "showMinWidth") {
            item.show = true
          }
        })
      }
    },
    heightTypeHandleCommand(val) {
      if (this.heightType === val) {
        return
      }
      this.heightType = val
      if (val === "%") {
        this.setParent("heightType")
        this.height = 100
      } else if (val === "自动") {
        this.setChild("heightType")
        this.height = "auto"
      } else {
        let zoom = this.$store.state[this.request_prefix]?.page?.zoom || 1
        let { boundHeight } = this.getBoundSize(this.ids)
        boundHeight = boundHeight / zoom
        this.height = Math.round(boundHeight) || 200
        this.showMaxHeight = false
        this.showMinHeight = false
        this.sizeLists.forEach(item => {
          if (item.value === "showMaxHeight" || item.value === "showMinHeight") {
            item.show = true
          }
        })
      }
    },
    getFocus(event) {
      this.isFocus = true
      event.currentTarget.select()
    },
    blurEvent(originName,name){
      this.isFocus = false
      sessionStorage.removeItem('tempSize')
      this.setValue(originName,name)
    },
    setValue(originName,name){
      if(this[name]){
        let val =  Number(this[name])
        // todo 处理最大值最小值
        // if(Number(this.max) && val > this.max){
        //   this[name] = this.max
        // }
        // if(Number(this.min) && val < this.min){
        //   this[name] = this.min
        // }
        this[originName] = val
      }else{
        // 不允许输入为空 为空的情况恢复原来的值
        this[name] = Number(this[originName])
      }
    },
    changeValue() {
      if (this.margin) {
        this.margin = null
      }
    },
    addHandleCommand(command, type, index) {
      console.log('command :>>', command, type, index);
      if (!command) return
      this[command] = true
      this.sizeLists.forEach(item => {
        if (item.value === command) {
          item.show = false
        }
      })
    },
    delHandleCommand(val) {
      console.log('val :>>', val);
      this[val] = false
      this.sizeLists.forEach(item => {
        if (item.value === val) {
          item.show = true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}

.color000 {
  color: var(--text);
}

::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}

::v-deep .input-size .el-input__suffix {
  right: 4px;
}

::v-deep .input-size.disabledInput .el-input__suffix .el-dropdown-link::after  {
  content: "";
  display: block;
  width: 86px;
  height: 32px;
  position: absolute;
  left: -59px;
  top: 0;
}

::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}

::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}

::v-deep .input-size.el-input.is-disabled .el-input__inner {
  background: var(--inputBackGround) !important;
}

.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}

.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 100px;
  padding-left: 36px;
  padding-right: 12px;
}

.el-dropdown-menu__item {
  color: var(--textColor);
  font-size: 13px;
}

.title-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--textColor);
  font-size: 16px;
}

.add-size {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);

  .el-dropdown-link {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    text-align: center;
    line-height: 24px;

    &:hover {
      background: rgba(31, 35, 41, 0.08);
    }
  }
}

.custom-menu {
  .el-dropdown-menu__item {
    line-height: 38px;
    padding: 0 12px;

    .icon {
      display: inline-block;
      vertical-align: top;
      margin-top: 10px;
      font-size: 16px;
      margin-right: 8px;
    }
  }
}</style>
